import React, { Component } from 'react';

class Example extends Component {
  render() {
    return (
      <div>
        <h1>Help</h1>
        <p>
          For help please contact sgd-programmers@lists.stanford.edu.
        </p>
      </div>
    );
  }
}

export default Example;



// WEBPACK FOOTER //
// ./containers/help/index.js